import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  allDocuments: [],
  loading: false,
  error: false,
};

const getAllDocumentsRequest = createAction("getAllDocumentsRequest");
const getAllDocumentsSuccess = createAction("getAllDocumentsSuccess");
const getAllDocumentsFailure = createAction("getAllDocumentsFailure");

export const documentsReducer = createReducer(initialState, (builder) => {
  builder
    // Get All Documents
    .addCase(getAllDocumentsRequest, (state) => {
      state.loading = true;
    })
    .addCase(getAllDocumentsSuccess, (state, action) => {
      state.loading = false;
      state.allDocuments = action.payload;
    })
    .addCase(getAllDocumentsFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
});
